import React, { useMemo } from "react";
import PremiumAccess from "../PremiumAccess";

const useGameResult = (scheduleItem: any, isHome: boolean, matchupTeamKey: string) => {
  return useMemo(() => {
    const { homeScore, awayScore } = scheduleItem;
    if (homeScore === null && awayScore === null) {
      return "";
    }

    const spread: number = scheduleItem?.line?.[`${matchupTeamKey}Spread`];
    const atsWin = scheduleItem?.line?.[`${matchupTeamKey}AtsWin`];

    const teamScore = isHome ? homeScore : awayScore;
    const oppScore = isHome ? awayScore : homeScore;

    // Show W
    // 1. When atsWin is true (calculated in backend)
    // 2. When spread is Even == 0 and home team won the game (like moneyline)
    if ((spread === 0 && teamScore > oppScore && atsWin === null) || (spread && atsWin !== null && atsWin)) {
      return "W";
    }

    // Show L
    // 1. When spread is not 0 and home team lose
    // 2. When spread is Even == 0 and home team lose the game
    if ((spread === 0 && teamScore < oppScore && atsWin === null) || (spread && !atsWin && atsWin !== null)) {
      return "L";
    }

    // Show P
    // 1. When there is a spread and home score + home spread === away score
    // 2. When spread is Even == 0, and home score, away score is matched
    if (
      (spread && Math.abs(homeScore - awayScore) === Math.abs(spread)) ||
      (atsWin === null && spread === 0 && homeScore === awayScore)
    ) {
      return "P";
    }

    // If spread === null or no scores
    return "";
  }, [scheduleItem, isHome, matchupTeamKey]);
};

// Cell which represents (at the spread)
const AtsCell = ({ scheduleItem, isHome, freeGame }: { scheduleItem: any; isHome: boolean; freeGame: boolean }) => {
  const matchupTeamKey = isHome ? "home" : "away";
  const spread: number = scheduleItem?.line?.[`${matchupTeamKey}Spread`];

  if (!scheduleItem.line) {
    return (
      <PremiumAccess scheduleItem={scheduleItem} source="ATS Cell" freeGame={freeGame}>
        <span className="schedule-list__table-cell">--</span>
      </PremiumAccess>
    );
  }

  const gameResult = useGameResult(scheduleItem, isHome, matchupTeamKey);
  const gameSpread = spread === 0 ? "Even" : spread > 0 ? `+${spread}` : (spread ?? "--"); // prettier-ignore

  return (
    <PremiumAccess scheduleItem={scheduleItem} source="ATS Cell" freeGame={freeGame}>
      <span
        className={`schedule-list__table-cell${
          gameResult && gameResult !== "P" ? (gameResult === "W" ? "-good" : "-bad") : ""
        }`}
      >
        {gameResult} {gameSpread}
      </span>
    </PremiumAccess>
  );
};

export default AtsCell;
